































































































































































































































































































































































































































import { deepCopy } from "deep-copy-ts";
import moment from "moment";
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  CustomersApi,
  GetCustomersResponse,
  GetLocationsCustomerResponse,
  NotificationModel,
  NotificationsApi,
  LocationsApi,
  TreatmentMonitoringApi,
  TreatmentMonitoringModel,
  UserModel,
  VariableDataModel,
  VariableModel,
  VariablesApi, TreatmentRequestsApi,
} from "../../../apis";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { ITreatmentMonitoring, msToVariableTime } from "./";
import StopTreatmentDialog from "../treatment-requests/StopTreatmentDialog.vue";
import TrackState from "../../mixin/TrackState.vue";
import { mixins } from "vue-class-component";
import VueSlickCarousel from "vue-slick-carousel";
import AlertDialog from "../common/AlertDialog.vue";

@Component({
  components: { MoreVertBtn, StopTreatmentDialog, VueSlickCarousel, AlertDialog },
  mixins: [TrackState],
})
export default class TreatmentMonitoringList extends mixins(TrackState) {
  getCustomersResponse: GetCustomersResponse = null;
  getLocationsCustomerResponse: GetLocationsCustomerResponse = null;
  locations: any = [];
  showRedDialog = false;
  listShow = false;
  showGreenDialog = false;
  redContent = "";
  redStop = false;
  shipmentWeight = true;
  greenContent = "";
  intervalId: any = null;
  boxSyncing = false;
  locationQueryParam = "";
  tab = null;
  search = null;
  searchForm = { customerId: "", locationId: "" };
  data: ITreatmentMonitoring[] = [];
  zoneData: any = [];
  selectedTreatmentMonitoring: ITreatmentMonitoring = null;
  selectedGreenVariable: VariableDataModel = null;
  showDialogConfirmNotTreatment = false;
  dialogConfirmNotTreatmentContent = "";
  dialogConfirmNotTreatmentTitle = "";

  panels = [];
  alarms: NotificationModel[] = [];
  alarmPage = 1;
  alarmCount = 0;
  alarmLimit = 10;
  loading: boolean = false;
  carouselSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    initialSlide: 0,
    responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false
          }
        }
      ]
  };
  showStartConfirmDialog = false;
  confirmContentStart = "";
  treatmentRequestIdSelect = "";

  onStartTreatmentRequest() {
    this.showStartConfirmDialog = true;
    this.confirmContentStart = this.$t("dialog.start.treatmentRequest").toString();
  }

  created() {
    if (!this.$util.isClient()) {
      try {
        new CustomersApi().getActiveCustomers().then((resp) => {
          this.getCustomersResponse = resp.data;
        });
        this.getActiveLocations();
      } catch (error) {
        this.$util.showError(error);
      }
    } else {
      const customerId = (this.$store.getters.user as UserModel).customerId;
      this.getActiveLocationsByCustomerId(customerId);
      this.onCustomerIdWatch(customerId);
    }
  }

  async getActiveLocations() {
    try {
      const res = await new LocationsApi().getActiveLocations();
      this.locations = res.data.data;
      const selectedLocation = this.locations.find(l=> l.id == this.searchForm.locationId);
          if (selectedLocation){
            document.title = selectedLocation.locationName + " - Treatment Monitoring";
          }
    } catch (error) {
      this.$util.showError(error);
    }
  }

  async getActiveLocationsByCustomerId(customerId : string) {
    try {
        new CustomersApi()
        .getActiveLocationsByCustomerId({ id: customerId })
        .then((res) => {
          this.locations = res.data.data;
          const selectedLocation = this.locations.find(l=> l.id == this.searchForm.locationId);
          if (selectedLocation){
            document.title = selectedLocation.locationName + " - Treatment Monitoring";
          }
        });
      } catch (error) {
        this.$util.showError(error);
      }
  }

  mounted() {
    if (this.popState()) {
      this.searchForm = deepCopy(this.popState());
      if (this.$route.query && this.$route.query.locationId){
       this.searchForm.locationId = this.$route.query.locationId.toString();
      }
      this.locationQueryParam = this.searchForm.locationId;
      this.onSearch();
      this.getAlarms();
    }
  }

  beforeDestroy() {
    this.clearInterval();
  }

  get CUSTOMERS() {
    return this.getCustomersResponse
      ? this.getCustomersResponse.data.map((val) => ({
          text: val.companyName,
          value: val.id,
        }))
      : [];
  }

  get LOCATIONS() {
    if (!this.searchForm.customerId) {
      const locations = this.lodash.map(this.locations, val => ({
        text: val.locationName,
        value: val.id,
        isOnline: val.isOnline,
        retry: val.retry,
      })).sort( (a,b)=> (a.text <= b.text) ? -1: 1);
      return locations;
    }
    if (this.getLocationsCustomerResponse) {
      const locations = this.getLocationsCustomerResponse.data.map((val) => ({
        text: val.locationName,
        value: val.id,
        isOnline: val.isOnline,
        retry: val.retry,
      })).sort( (a,b)=> (a.text <= b.text) ? -1: 1);
      // this.searchForm.locationIds = locations.map((l) => l.value);
      return locations;
    }
    return [];
  }

  get ICONS() {
    return [
      { id: 1, text: "O2 Down", value: "O2_DOWN" },
      { id: 2, text: "Flushing", value: "FLUSHING" },
      { id: 3, text: "Pulldown", value: "PULLDOWN" },
      { id: 4, text: "O2 Up", value: "O2_UP" },
      { id: 5, text: "Ventilator", value: "VENTILATOR" },
      { id: 6, text: "Heater", value: "HEATER" },
      { id: 7, text: "Humidifier", value: "HUMIDIFIER" },
      { id: 8, text: "Dehumidification", value: "DEHUMIDIFICATION" },
      { id: 9, text: "Overflow (give)", value: "OVERFLOW_GIVE" },
      { id: 10, text: "Overflow (receive)", value: "OVERFLOW_RECEIVE" },
      { id: 11, text: "Air compressor", value: "AIR_COMPRESSOR" },
      { id: 12, text: "N2 generator", value: "N2_GENERATOR" },
      { id: 13, text: "Green Light", value: "GREEN_LIGHT" },
      { id: 14, text: "Red Light", value: "RED_LIGHT" },
      { id: 15, text: "Tempt Up", value: "TEMPT_UP" },
      { id: 16, text: "Temp Down", value: "TEMP_DOWN" },
    ];
  }

  get ACTIONS(): IAction[] {
    return [
      {
        titleName: `1 ${this.$t("text.Box")}`,
        titleStyle: "color: black; font-weight: 600",
        action: "1",
      },
      {
        titleName: `2 ${this.$t("text.Boxes")}`,
        titleStyle: "color: black; font-weight: 600",
        action: "2",
      },
      {
        titleName: `3 ${this.$t("text.Boxes")}`,
        titleStyle: "color: black; font-weight: 600",
        action: "3",
      },
      {
        titleName: `4 ${this.$t("text.Boxes")}`,
        titleStyle: "color: black; font-weight: 600",
        action: "4",
      },
      {
        titleName: `5 ${this.$t("text.Boxes")}`,
        titleStyle: "color: black; font-weight: 600",
        action: "5",
      },
      {
        titleName: `6 ${this.$t("text.Boxes")}`,
        titleStyle: "color: black; font-weight: 600",
        action: "6",
      },
      {
        titleName: `7 ${this.$t("text.Boxes")}`,
        titleStyle: "color: black; font-weight: 600",
        action: "7",
      },
      {
        titleName: `8 ${this.$t("text.Boxes")}`,
        titleStyle: "color: black; font-weight: 600",
        action: "8",
      },
    ];
  }
  handleAlarmClick(event) {
    if (event.target && event.target.classList.contains("treatment-notification")) {
      const code: string = event.target.getAttribute("code");
      if ([ "TREATMENT_START", "TREATMENT_STOP", "TREATMENT_RECOUNT", "TREATMENT_REACHED", "TREATMENT_REACHED_ALL", "TREATMENT_OUT_OF_REACH" ].includes(code)) {
        this.$router.replace({
          name: "monitoring-detail",
          params: { id: event.target.getAttribute("unitId") || "" },
          query: { t: "" + new Date().getTime() },
        });
      } else {
        this.$router.replace({
          name: "view-treatment-request",
          params: { id: event.target.getAttribute("treatmentId") },
          query: { t: "" + new Date().getTime() },
        });
      }
    }
  }
  getColors(index: number) {
    const colors = ['#3276D8','#E54949','#42D69E'];
    const size = colors.length;
    return colors[index % size];
  }

  getVariableValue(id: string, unitId: string) {
    const monitoring = this.data.find((val) => val.unitId === unitId);
    const variable = this.lodash.find(
      !monitoring ? [] : monitoring.variablesOrigin,
      (val) => val.variable.id === id
    );
    if (!variable) {
      return "";
    }
    return variable.value;
  }

  infiniteScrolling(entries, observer, isIntersecting) {
    if (!isIntersecting) {
      return;
    }
    // setTimeout(() => {
    if (!document.querySelector(".alarm-waning.expand-transition-enter")) {
      this.alarmPage++;
      this.getAlarms();
    }
    // }, 500);
  }

  getAlarm(item: NotificationModel) {
    const param = {};
    item.params.forEach((val: { field: string; value: string }) => {
      if (val.field === "dateTime")
        param[val.field] = moment
          .utc(val.value, "YYYY-MM-DD HH:mm:ss")
          .local()
          .format("YYYY-MM-DD HH:mm");
      else param[val.field] = val.value;
    });
    return "- " + this.$t(`notification.type.${item.code}`, param);
  }

  onChangeDropDown(
    variableId: string,
    index: number,
    val: ITreatmentMonitoring
  ) {
    val.variables[index].variable.id = variableId;
  }

  onChangeAlarm() {
    if (this.panels.length === 1) {
      return;
    }
    this.alarmPage = 1;
    this.getAlarms(true);
  }

  onSelectedAction({ action, item: unitId }: { action: string; item: string }) {
    const boxCount = Number.parseInt(action);
    const treatmentMonitoring = this.data.find((val) => val.unitId === unitId);
    treatmentMonitoring.variables = this.lodash.take(
      treatmentMonitoring.variables,
      boxCount
    );
    const actualCount = treatmentMonitoring.variables.length;
    if (actualCount < boxCount) {
      for (let i = 1; i <= boxCount - actualCount; i++) {
        const variable = {
          id: "",
        } as VariableModel;
        const variableData = { variable } as VariableDataModel;
        treatmentMonitoring.variables.push(variableData);
      }
    }
    this.syncToStore(unitId);
  }

  async syncToStore(unitId: string) {
    // this.boxSyncing = true;
    // const treatmentMonitoring = this.data.find((val) => val.unitId === unitId);
    // const variableIds = treatmentMonitoring.variables.map(
    //   (val) => val.variable.id
    // );
    // try {
    //   const rs = await new TreatmentMonitoringApi().saveBoxSetting({
    //     postTreatmentBoxSetting: {
    //       unitId,
    //       variableIdList: variableIds || [],
    //     },
    //   });
    // } finally {
    //   this.boxSyncing = false;
    // }
    let history: ITreatmentMonitoring[] =
        this.$store.getters.treatmentMonitoring;
    history = history? history : [];
    this.data.forEach((item) => {
      history = history.filter(h => h.unitId != item.unitId);});
    this.data.forEach((item) => {
      const variableDataModels = item.variables.map(
        (val) =>
          ({
            id: val.id,
            variable: {
              id: val.variable.id,
            },
          } as VariableDataModel)
      );
      history.push({
        unitId: item.unitId,
        variables: variableDataModels,
      });
    });
    this.$store.commit("SET_TREATMENT_MONITORING", history);
  }

  @Watch("searchForm.customerId")
  onCustomerIdWatch(newVal, oldVal?) {
    // this.$util.showLoading();
    if (newVal) {
      try {
        new CustomersApi()
        .getActiveLocationsByCustomerId({ id: newVal })
        .then((resp) => {
          this.getLocationsCustomerResponse = resp.data;
        });
      } catch (error) {
        this.$util.showError(error);
      }
    } else {
      this.getActiveLocations();
    }
    // this.$util.hideLoading();
  }

  async processData(arrs: TreatmentMonitoringModel[]) {
    const data = [];
    for (const item of arrs) {
      if (!item) continue;
      const monitoring: ITreatmentMonitoring = {};
      monitoring.treatmentRequestId = item.id;
      monitoring.autoStopDate = item.autoStopDate;
      monitoring.treatmentNumber = !item.treatmentNumber
        ? ""
        : "" + item.treatmentNumber;
      monitoring.unitId = item.unit.id;
      monitoring.unitName = item.unit.name;
      monitoring.freeText = item.unit.freeText? item.unit.freeText.trim(): '';
      monitoring.zone = item.unit.zone ? item.unit.zone : 1 ;
      monitoring.unitType = item.unit.type ? item.unit.type : '' ;
      monitoring.locationName = item.location.locationName;
      monitoring.locationId = item.location.id;
      monitoring.status = item.status ? item.status.toUpperCase() : "";
      monitoring.inProgress = this.lodash.find(item.variableData,
        (val) => val.variable.inProgress && val.value === 1
      )
        ? true
        : false;
      // this.lodash.sortBy(this.lodash.filter(
      //   item.variableData,
      //   (val) => val.variable.type && val.variable.type.toUpperCase() === "BOOL"
      // ), val => this.lodash.findIndex(this.ICONS, icon => icon.value === val.variable.icon))
      monitoring.variablesIcon = this.lodash.sortBy(
        this.lodash.filter(
          item.variableData,
          (val) =>
            val.variable.type && val.variable.type.toUpperCase() === "BOOL"
        ),
        (val) =>
          this.lodash.findIndex(
            this.ICONS,
            (icon) => icon.value === val.variable.icon
          )
      );
      monitoring.variableO2Up = this.lodash.find(
        monitoring.variablesIcon,
        (val) => val.variable.o2Up === true
      );
      monitoring.variableStartStop = this.lodash.find(
        monitoring.variablesIcon,
        (val) => val.variable.startStop === true
      );
      monitoring.variableGreenButton =
        this.lodash.filter(
          monitoring.variablesIcon,
          (val) => val.variable.greenButton === true
        ) || [];
      try {
        const resp = await new VariablesApi().getVariablesByUnitId({
          id: monitoring.unitId,
        });
        monitoring.variablesDropdown = resp.data.data.filter((v) => v.home);
      } catch (error) {
        this.$util.showError(error);
      }
      const history: ITreatmentMonitoring[] =
        this.$store.getters.treatmentMonitoring;
      const history_ = history.find((val) => val.unitId === monitoring.unitId);
      if (this.lodash.isEmpty(history) || this.lodash.isEmpty(history_)) {
        monitoring.variables = this.lodash.sortBy(
          this.lodash.filter(item.variableData, (v) => v.variable.home),
          (v) => v.variable.variableName
        );
      } else {
        monitoring.variables = history_.variables;
      }
      monitoring.variablesOrigin = deepCopy(item.variableData);

      // const boxResp = (await new TreatmentMonitoringApi().getBoxSetting({
      //   unitId: monitoring.unitId,
      // })) as AxiosResponse<PostTreatmentBoxSettingResponse>;
      // const variables_: VariableDataModel[] = [];
      // if (boxResp.data.data) {
      //   boxResp.data.data.variableList.forEach((val) => {
      //     if (!val) {
      //       const variable = { variable: { id: "" } } as VariableDataModel;
      //       variables_.push(variable);
      //     } else {
      //       const variable = item.variableData.find(
      //         (v) => v.variable.id === val.id && v.variable.home
      //       );
      //       if (variable) {
      //         variables_.push({
      //           variable: { id: variable.variable.id },
      //         } as VariableDataModel);
      //       }
      //     }
      //   });
      //   monitoring.variables = variables_;
      // } else {
      //  monitoring.variables = item.variableData.filter((v) => v.variable.home);
      // }
      monitoring.remainingO2DownTime = item.remainingO2DownTime;
      monitoring.remainingO2DownType = item.remainingO2DownType;

      data.push(monitoring);
    }
    this.data = data;
    const groupZone = this.lodash.groupBy(this.lodash.filter(data, (treatment) => treatment.locationId === this.locationQueryParam), (treatment) => treatment.zone);
    this.zoneData = Object.keys(groupZone).map(key => ({ 'zone': key, 'data': groupZone[key] }));

  }

  clearInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  onChangeCustomer(val) {
    // if (val) {
    //   this.searchForm.locationIds = this.LOCATIONS.map((l) => l.value);
    // } else {
    //   this.searchForm.locationIds = [];
    // }
    this.clearInterval();
  }
  intervalSearch(){
    if (!this.boxSyncing && !this.loading) {
           this.doSearch();
        }
  }
  async onSearch() {
    this.clearInterval();
    this.resetData();
    this.locationQueryParam = this.searchForm.locationId;
    const selectedLocation = this.LOCATIONS.find(l=> l.value == this.locationQueryParam);
    if (selectedLocation){
      document.title = selectedLocation.text + " - Treatment Monitoring";
    }
    this.pushState(deepCopy(this.searchForm));
    this.$util.showRouting();
    try {
      await this.doSearch();
      if (!(this as any)._isDestroyed) {
        this.intervalId = setInterval(this.intervalSearch, 3000);
      }
    } catch (error) {
      this.$util.showError(error);
      this.clearInterval();
    } finally {
      this.$util.hideRouting();
    }
  }

  async doSearch() {
    if (!this.$util.isClient() && !this.searchForm.locationId) {
      return;
    }
    try {
      this.loading = true;
      const rs = await new TreatmentMonitoringApi().getTreatmentMonitoring({
        // customerId: this.searchForm.customerId,
        locationIdList: this.locationQueryParam,
      });
      if ((this as any)._isDestroyed) return;
      const request_data = rs.data.data;
      const monitoringModel = request_data? request_data[0]: null;
      if (
        monitoringModel &&
        monitoringModel.customer
        // &&
        // monitoringModel.customer.id === this.searchForm.customerId &&
        // !this.$util.isClient()
      ) {
        await this.processData(rs.data.data);
      }
    } catch (error) {
      // this.resetData();
      this.$util.showError(error);
      if (error && error.data && error.data.messages){
        if (error.data.messages.find(m=> m.code == "invalid_location_connection")){
          this.clearInterval();
        }
      }
      // this.clearInterval();
    } finally {
      this.loading = false;
    }
  }

  resetData() {
    this.data = [];
    this.zoneData = [];
  }

  getAlarms(reset?: boolean) {
    new NotificationsApi()
      .getAlarmNotificationsByLocation({
        locationId: this.locationQueryParam,
      })
      .then((resp) => {
        if (reset) this.alarms = resp.data.data;
        else this.alarms = this.alarms.concat(resp.data.data);
        this.alarmCount = resp.data.count;
      });
  }

  getRedButtonClass(val: ITreatmentMonitoring) {
    if (!val.variableO2Up || !val.variableStartStop) {
      return;
    }
    const classes = [];
    const starstop = val.variableStartStop.value;
    const o2Up = val.variableO2Up.value;
    if (starstop === 0 && o2Up === 0) {
      classes.push("tw-opacity-25");
    }
    if (starstop === 0 && o2Up === 1) {
      return "tw-animate-pulse";
    }
    return classes;
  }

  getGreenButtonClass(greenVar: VariableDataModel) {
    const classes = [];
    if (!greenVar || !greenVar.value || greenVar.value === 0) {
      classes.push("tw-opacity-25");
    }
    return classes;
  }

  getRedImage(val: ITreatmentMonitoring) {
    if (!val.variableO2Up || !val.variableStartStop) {
      // return require("../../../assets/img/variable/green.png");
      return require("../../../assets/img/variable/red13.png");
    }
    const starstop = val.variableStartStop.value;
    const o2Up = val.variableO2Up.value;
    if (starstop === 0 && (o2Up === 0 || o2Up === 1)) {
      return require("../../../assets/img/variable/red13.png");
    }
    if (starstop === 1 && (o2Up === 0 || o2Up === 1)) {
      return require("../../../assets/img/variable/red24.png");
    }
    return "";
  }

  async onRedButton(val: ITreatmentMonitoring) {
    if (this.$util.isClient()) return;
    if (!val.treatmentRequestId) {
      this.showDialogConfirmNotTreatment = true;
      this.dialogConfirmNotTreatmentContent = this.$t("dialog.notTreatment.start").toString();
      this.dialogConfirmNotTreatmentTitle = this.$t("text.startTreatment").toString();
      return;
    }
    const rs = await new TreatmentRequestsApi().getTreatmentRequest({
      id: val.treatmentRequestId
    });
    this.treatmentRequestIdSelect = val.treatmentRequestId;
    const treatmentRequest = rs.data.data[0];
    if (treatmentRequest.status === "In Request") {
      this.onStartTreatmentRequest();
    } else {
      if (!val.variableO2Up || !val.variableStartStop) {
        this.$util.showError("treatment_monitoring_red_button_invalid");
        return;
      }
      const starstop = val.variableStartStop.value;
      const o2Up = val.variableO2Up.value;
      if (starstop === 0 && (o2Up === 0 || o2Up === 1)) {
        if (o2Up === 1) {
          return;
        }
        this.redStop = false;
        this.redContent = this.$t("dialog.redButton.content1").toString();
      }
      if (starstop === 1 && (o2Up === 0 || o2Up === 1)) {
        this.redStop = true;
        this.redContent = this.$t("dialog.redButton.content2").toString();
      }
      this.selectedTreatmentMonitoring = val;
      this.showRedDialog = true;
    }
  }

  async onOkConfirmDialog() {
    this.$util.showLoading();
    try {
      await new TreatmentRequestsApi().startTreatmentRequest({
        id: this.treatmentRequestIdSelect,
      });
      this.showStartConfirmDialog = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onGreenButton(item: ITreatmentMonitoring, greenVar: VariableDataModel) {
    if (this.$util.isClient()) return;
    this.selectedGreenVariable = greenVar;
    this.selectedTreatmentMonitoring = item;
    if (!greenVar) {
      this.$util.showError("treatment_monitoring_green_button_invalid");
      return;
    }

    if (greenVar.value === 1) {
      this.greenContent = this.$t("dialog.greenButton.content2", {
        name: greenVar.variable.variableName,
      }).toString();
    } else {
      this.greenContent = this.$t("dialog.greenButton.content1", {
        name: greenVar.variable.variableName,
      }).toString();
    }
    this.showGreenDialog = true;
  }

  async onOkGreenDialog() {
    this.$util.showLoading();
    try {
      await new TreatmentMonitoringApi().doGreenButtonAction({
        postGreenButtonActionRequest: {
          // treatmentId: this.selectedTreatmentMonitoring.treatmentRequestId,
          // unitId: this.selectedTreatmentMonitoring.unitId,
          locationId: this.selectedTreatmentMonitoring.locationId,
          variableId: this.selectedGreenVariable.variable.id,
        },
      });
      this.showGreenDialog = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  getRemainingO2DownTime(val: number, type: string) {
    if (type && type !== 'TIME') return val;
    return !val ? "" : msToVariableTime(val/1000);
  }
  getVariables(item: ITreatmentMonitoring, currentId: string) {
    const { variablesDropdown = [], variables = [] } = item;
    const currentBoxVariables = variablesDropdown.find(val => val.id === currentId);
    const allBoxVariables = variables.filter(val => val.variable && val.variable.id).map(val => val.variable.id);
    const otherBoxVariables = variablesDropdown.filter(val => !allBoxVariables.includes(val.id));
    otherBoxVariables.push(currentBoxVariables);
    return [...otherBoxVariables];
  }
}
